import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ContactComponent from '../components/ContactComponent'
import BreadCrumb from '../components/BreadCrumb'

import { Helmet } from "react-helmet";
import ScrollNavbar from '../components/ScrollNavbar'
import CustomerFeedback from '../components/main/CustomerFeedback'

const ContactPage = () => {
  return (
    <div>
       <Helmet>
        <title>Contact FluffyTouch | At-Home Pet Grooming Experts</title>
        <meta
          name="description"
          content="Contact FluffyTouch's pet care team! Book at-home grooming, ask about services, or get emergency matting help. 24/7 WhatsApp support available"
        />
      </Helmet>
      <ScrollNavbar/>
        <Navbar/>
        <BreadCrumb name="Contact Us"/>

        <ContactComponent/>

        <div   className='ft-customer-rev-of-contact-us'>
        <CustomerFeedback viewMoreValue="active" />

        </div>


        <Footer/>
    </div>
  )
}

export default ContactPage